<template>
  <div class="modal">
    <div class="modal__card">
      <div class="modal__info">
        <p @click="modalInfo = true" :class="{'info-active':modalInfo}">Shopping</p>
        <p @click="modalInfo = false" :class="{'info-active':!modalInfo}">Kredit</p>
      </div>
      <Transition name="info" mode="out-in">
        <div v-if="modalInfo" class="modal__card-shop">
          <div class="modal__card-one">
            <h2 class="modal__title">Xarid qiling</h2>
            <img class="modal__img" :src="modalObject.img" alt="">
          </div>
          <div class="modal__card-two">
            <p class="modal__price">{{modalObject.price}} sum -- 1 dona</p>
            <button class="modal__btn" @click="alert"><a href="/">Shopping</a></button>
          </div>
        </div>
        <div v-else class="modal__card-kredet">
          <div class="modal__card-one">
            <h2 class="modal__title">Bo'lib to'lash</h2>
            <img class="modal__img" :src="modalObject.img" alt="">
          </div>
          <div class="modal__card-two">
            <p class="modal__price">{{modalObject.price}} sum -- 1 dona</p>
            <p class="modal__price-kredet">Oyiga {{Math.ceil(modalObject.price / kredetMonth)}} sum</p>
            <div class="modal__card-kredet__btn">
              <button @click="kredetMonth > 1 ? kredetMonth-- : 0">-</button>
              <p>{{ kredetMonth }}</p>
              <button @click="kredetMonth < 10 ? kredetMonth++ : kredetMonth">+</button>
            </div>
            <button class="modal__btn" @click="alert"><a href="/">Shopping</a></button>
          </div>
        </div>
      </Transition>
    </div>
    <img class="modal__card-close" @click="$emit('modalBool',false)" src="/img/close.d0451642.svg" alt="">
  </div>
</template>

<script>
export default {
  props:{
    modalObj:Object
  },
  data(){
    return{
      modalInfo:true,
      modalObject: this.modalObj,
      kredetMonth: 1
    }
  },
  methods:{
    alert(){
      alert(`Tavar: ${this.modalObject.title}, ${this.modalObject.price} sum`)
    }
  }
}
</script>

<style lang="scss">
.modal{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  &__info{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 10px;
    p{
      font-size: 14px;
      border: 1px solid rgb(253, 187, 20);
      padding: 5px 10px;
      border-radius: 10px 0 0 10px;
      cursor: pointer;
    }
    p:last-of-type{
      border-radius: 0 10px 10px 0;
    }
    .info-active{
      background: rgb(253, 187, 20);
    }
  }
  &__title{
    font-size: 20px;
    font-weight: 400;
  }
  &__img{
    max-width: 200px;
    width: 100%;
    margin: 40px 0 10px;
  }
  &__price{
      font-size: 18px;
      margin-bottom: 20px;
  }
  &__btn{
      font-size: 16px;
      border-radius: 3px;
      border: 1px solid #384685;
      background: unset;
      padding: 5px 10px;
      line-height: 1.2;
      a{
        color: black;
      }
  }
  &__card{
    max-width: 600px;
    width: 100%;
    margin: 0 20px;
    height: auto;
    background: #fff;
    box-shadow: 0 0 10px rgba(106, 106, 106, 0.741);
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;
    position: relative;
    &-close{
      position: absolute;
      top: 30px;
      right: 30px;
      cursor: pointer;
    }
    &-shop{
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 30px;
    }
    &-kredet{
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 20px;
      &__btn{
        max-width: 100px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        button{
          width: 25px;
          height: 25px;
          font-size: 20px;
          line-height: 1;
          border-radius: 5px;
          background: #ffffff;
          box-shadow: 0 0 10px rgb(0 0 0 / 10%);
          border-radius: 5px;
        }
      }
    }
  }
}
.info-enter-active,
.info-leave-active {
  transition: all 0.3s ease;
}
.info-enter-from,
.info-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>